<app-products-breadcrumb></app-products-breadcrumb>

<div class="container-fuid bg-white my-4">
  <div class="container">
    <div class="ps-layout--shop">
      <section>
        <app-products-showcase></app-products-showcase>
      </section>
    </div>
  </div>
</div>
